export default (type, payload = {}) => {
  const params = Object.keys(payload);
  return params.reduce((acc, param) => ({ ...acc, [param]: payload[param] }), {
    type,
  });
};
